export default "__VITE_ASSET__CaoNxLvB__"